import { BaseService } from './base.service.js';
class TestService extends BaseService {
    async getTestCases() {
        const res = await this.fetch('/test/cases');
        return res.data;
    }
    async createTestCase(dto) {
        const res = await this.fetch('/test/case', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dto),
        });
        return res.data;
    }
    async updateTestCase(id, dto) {
        const res = await this.fetch(`/test/case/${id}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dto),
        });
        return res.data;
    }
    async removeTestCase(id) {
        await this.fetch(`/test/case/${id}`, {
            method: 'DELETE',
        });
    }
}
export const testService = new TestService();
